<template>
    <div class="absolute z-10 overflow-y-auto top-0 w-full left-0 " id="modal">
        <div class="flex items-center justify-center h-auto pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity"><div class="absolute inset-0 bg-gray-900 opacity-75" /></div>
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
            <div class="inline-block align-center bg-white rounded-lg text-left overflow-hidden shadow-xl xl:mt-8 lg:mt-8 md:mt-6 sm:mt-1 p-2 transform transition-all" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                <div class="bg-white p-1">
                    <div class="flex flex-col items-center">
                        <div class="">
                            <img class="xl:w-60 lg:w-60 md:w-16 sm:w-16" :src="starCondition" alt="star">
                        </div>
                        <div class="-translate-y-14">
                            <p class="text-2xl font-bold shadow-lg shadow-gray-500 p-5 rounded-lg mt-8">สำเร็จเเล้วไปด่านต่อไปกัน</p>
                        </div>
                        <div class="flex justify-around gap-x-20 p-10">
                            <div class="flex flex-col items-center hover:ring-4 p-4 border rounded-lg shadow-lg shadow-gray-500" @click="resetGame()">
                                <div>
                                    <img class="xl:w-32 lg:w-32 md:w-14 sm:w-14" src="../assets/materials/reload.png" alt="reload">
                                </div>
                                <div>
                                    <p class="text-base">เล่นอีกครั้ง</p>
                                </div>
                            </div>
                            <div class="flex flex-col items-center hover:ring-4 p-4 border rounded-lg shadow-lg shadow-gray-500" @click="nextCheckPoint()">
                                <div>
                                    <img class="xl:w-32 lg:w-32 md:w-14 sm:w-14" src="../assets/materials/arrow.png" alt="arrow">
                                </div>
                                <div>
                                    <p class="text-base">ด่านต่อไป</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>           
            </div>
        </div>
    </div>

    <!-- <div class="absolute w-screen h-screen left-0 top-0 bg-transparent rounded-lg shadow-lg shadow-orange-300 drop-shadow-lg p-4">
            <div class="h-full w-full flex flex-col justify-around items-center xl:gap-y-2 lg:gap-y-2">
              <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div class="flex flex-col items-center">
                        <div class="">
                            <img class="w-60" :src="starCondition" alt="star">
                        </div>
                        <div class="-translate-y-14">
                            <p class="text-2xl font-bold shadow-lg shadow-gray-500 p-5 rounded-lg">สำเร็จเเล้วไปด่านต่อไปกัน</p>
                        </div>
                        <div class="flex justify-around gap-x-20 p-10">
                            <div class="flex flex-col items-center hover:ring-4 p-4 border rounded-lg shadow-lg shadow-gray-500" @click="resetGame()">
                                <div>
                                    <img class="w-32" src="../assets/materials/reload.png" alt="reload">
                                </div>
                                <div>
                                    <p class="text-base">เล่นอีกครั้ง</p>
                                </div>
                            </div>
                            <div class="flex flex-col items-center hover:ring-4 p-4 border rounded-lg shadow-lg shadow-gray-500" @click="nextCheckPoint()">
                                <div>
                                    <img class="w-32" src="../assets/materials/arrow.png" alt="arrow">
                                </div>
                                <div>
                                    <p class="text-base">ด่านต่อไป</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>  -->
</template>

<script>

const checkStar = (star) => {
    if(star === 1) {
        return '../assets/star/one-star.png';
    }else if(star === 2) {
        return '../assets/star/two-star.png';
    }else {
        return '../assets/star/tree-star.png';
    }
}

export default {
    name: "Correct",
    props: {
        resetGame: Function,
        nextCheckPoint: Function,
        star: Number
    },
    data() {
        return {
            starCondition: this.star ? checkStar(this.star) : '../assets/star/tree-star.png'
        }
    }
};
</script>